export function register() {
    if ("serviceWorker" in navigator) {
      window.addEventListener("load", () => {
        const swUrl = "/sw.js";
        navigator.serviceWorker
          .getRegistrations()
          .then((registrations) => {
            // Verifica se já existe um Service Worker registrado
            const isAlreadyRegistered = registrations.some(
              (reg) => reg.active && reg.active.scriptURL.includes("sw.js")
            );
            if (!isAlreadyRegistered) {
              navigator.serviceWorker
                .register(swUrl)
                .then((registration) => {
                  console.log("Service Worker registrado:", registration);
                })
                .catch((error) => {
                  console.error("Erro ao registrar o Service Worker:", error);
                });
            } else {
              console.log("Service Worker já está registrado.");
            }
          });
      });
    } else {
      console.log("Service Workers não suportados.");
    }
  }
  
  export function unregister() {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.ready.then((registration) => {
        registration.unregister();
        console.log("Service Worker desregistrado.");
      });
    }
  }